import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Grid, Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	root: {},
}));

const Header = (props) => {
	const { module, view, actions, className, ...rest } = props;

	const classes = useStyles();

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<Grid
				alignItems="flex-end"
				container
				justifyContent="space-between"
				spacing={3}
			>
				<Grid item>
					<Typography component="h2" gutterBottom variant="overline">
						{module}
					</Typography>
					<Typography component="h1" variant="h3">
						{view}
					</Typography>
				</Grid>
				{actions
					&& (
						<Grid item>
							{actions}
						</Grid>
					)}
			</Grid>
		</div>
	);
};

Header.propTypes = {
	className: PropTypes.string,
	module: PropTypes.string,
	view: PropTypes.string,
	actions: PropTypes.object
};

Header.defaultProps = {};

export default Header;
